import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"






var image
var content = {
  hero: {
    title: <span>Hands-On Cyber Training with <br/>Project Ares</span>,
    text: (
      <span>
        <h2> Does organizational cyber risk keep you up at night? </h2>
        <br />
        In the wake of{" "}
        <strong>
          {" "}
          persistent cyber-attacks on financial organizations
        </strong>{" "}
        and departments worldwide, the C-Suite and security and risk leaders
        need proactive solutions that prioritize risk mitigation.{" "}
        <strong> Immersive cyber training</strong> can alleviate concerns
        related to issues of <strong> compliance, cyber ‘insecurity,’</strong>{" "}
        and <strong> rapid incident response.</strong> <p>Company networks are
        better protected with professionals who are prepared to address any
        adversarial attack at a moment’s notice.</p> 
        
        Help your cyber professionals train with Project Ares: a hands-on cyber
        training solution, so that security posture is strengthened persistently
        and proactively.{" "}
      </span>
    ),
  },

  calendly: {
    text:  <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
  },

  cta1: {
    title: <span>How cyber security and risk mitigation go<br/> hand-in-hand. </span>,
    text:
      " ",
    url:
      "https://marketing.circadence.com/acton/media/36273/webinar-20q3-fei-webinar",
    cta: "Watch Webinar Now",
  },
      
  cta2: {
    title: "Invest in your cyber security team! ",
    text:
      "Learn more about Project Ares plans to keep professional's cyber skills sharp in your organization. ",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social: {
    social1: {
      image: "",
      title: "",

      text: (
        <span>
         Only 38% of FSI organizations report having the necessary cyber security skills to mitigate risks.
          <span className="source">
            - Synopsys & Ponemon Institute Report
          </span>
        </span>
      ),
      url: "/teach",
    },
  },
  //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources: {
    resource1: {
      title: <span>5 Strategies to Fill the Cybersecurity Skills Gap <span>Infographic</span></span>,
      text:
        <span>Financial services organizations face widening gaps in acquiring and developing strong cyber talent. Discover five ready-to-implement ways to maintain a cyber-ready team. </span>,
      url:
        "https://staging.circadence.com/wp-content/uploads/2019/03/5-strategies-to-fill.pdf",
    },
    resource2: {
      title: <span>Building a Fierce Financial Workforce <span>White Paper</span> </span>,
      text:<span>Discover the value and benefit of continually upskilling cyber professionals and positive implications it can have on overall organizational readiness against imminent threats.  </span>,
      url:        "https://marketing.circadence.com/acton/media/36273/building-a-fierce-financial-cybersecurity-workforce-white-paper",
    },
    resource3: {
      title: <span>How to Protect your Financial Services Company<span>E-Book</span></span>,
      text:
        <span>Insider threats pose significant risk to your organization. Learn how persistent cyber training of professionals can help spot insider threats and reduce probabilities of a cyber-attack.</span>,
      url:
        "https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00e1/t/page/fm/0",
    },
  },
  simple: {
    simple1: {
      text: "Build specialized skills aligned to NIST/NICE’s Work Role Framework.",
    },
    simple2: {
      text:
        "Quickly respond to cyber-attacks by training in realistic scenarios inspired by the latest threats.",
    },
    simple3: {
      text:
        "Integrate skills and optimize strategic thinking abilities with multi-faceted cyber activities.",
    },
    simple4: {
      text:
        "Train on your terms with browser-based access to learn skills anytime.",
    },
   
  },
}

class LearnPage extends React.Component {
  render() {
    return (
      <Layout>
      <SEO title={seodata.fsi.title} description={seodata.fsi.description} keywords={seodata.fsi.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name={"buildings"} />}
        />

<Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />

           <a  style ={{textDecoration:"none"}}href="https://www.synopsys.com/content/dam/synopsys/sig-assets/reports/software-security-financial-services-ponemon.pdf" target="_blank">     
<SocialSlider>
    <SimpleSlide   image={<HandleImages name={'womanBenchServers'}/>} text={content.social.social1.text} />
   
 

        </SocialSlider></a>
        <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
          url={content.cta1.url}
          inv={false}
          bgColor={"deep-blue"}
          image={"laptopF"}
        />

 
<h3>Additional Resources </h3>
        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"arrow"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"manLaptop"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"fSISketch"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
        </ResourcesWrapper>

        <SimpleSlider>
          <SimpleSlide
            image={<HandleImages name={"pAScreen1"} />}
            text={content.simple.simple1.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen2"} />}
            text={content.simple.simple2.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen3"} />}
            text={content.simple.simple3.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen4"} />}
            text={content.simple.simple4.text}
          />
         
        </SimpleSlider>
        <br />
    

        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />

      </Layout>
    )
  }
}

export default LearnPage
